export default __webpack_public_path__ + "static/media/Paid_Stamp.59f02775.jpg";